import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projet-professionnel-formations-item',
  templateUrl: './projet-professionnel-formations-item.component.html',
  styleUrls: ['./projet-professionnel-formations-item.component.scss']
})
export class ProjetProfessionnelFormationsItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
